var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"item-border mt-3 pa-3 pr-5 pl-5"},[_c('h1',[_vm._v(_vm._s(_vm.header))]),(_vm.hasData)?_c('apexchart',{attrs:{"type":"bar","height":"350","options":_vm.chartOptions,"series":_vm.series}}):_c('p',{staticClass:"goals-chart__empty"},[_vm._v(" No monthly progress has been recorded yet. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }